var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15835_81776",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15835_81776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9909 18.9077L21.5192 17.4104C21.7363 17.0275 21.9034 16.603 22.0205 16.137C22.1376 15.6713 22.1962 15.1811 22.1962 14.6667H24.1962C24.1962 15.4907 24.0902 16.2518 23.8782 16.95C23.6662 17.6483 23.3704 18.3008 22.9909 18.9077ZM18.6985 14.5744L16.8629 12.7384V6.6667C16.8629 6.28892 16.7351 5.97225 16.4795 5.7167C16.224 5.46114 15.9073 5.33336 15.5295 5.33336C15.1517 5.33336 14.8351 5.46114 14.5795 5.7167C14.324 5.97225 14.1962 6.28892 14.1962 6.6667V10.046L12.1962 8.04603V6.6667C12.1962 5.73514 12.5189 4.9467 13.1642 4.30136C13.8095 3.65603 14.598 3.33336 15.5295 3.33336C16.4611 3.33336 17.2495 3.65603 17.8949 4.30136C18.5402 4.9467 18.8629 5.73514 18.8629 6.6667V13.7947C18.8629 13.9451 18.8457 14.0819 18.8115 14.205C18.7773 14.3281 18.7396 14.4513 18.6985 14.5744ZM14.5295 27.6667V23.2717C12.3295 23.0204 10.5017 22.0768 9.04619 20.441C7.59063 18.805 6.86285 16.8803 6.86285 14.6667H8.86285C8.86285 16.5111 9.50597 18.0834 10.7922 19.3834C12.0786 20.6834 13.6577 21.3334 15.5295 21.3334C16.3875 21.3334 17.194 21.1804 17.9489 20.8744C18.7035 20.5684 19.3714 20.1445 19.9525 19.6027L21.3782 21.028C20.7337 21.6334 20.0004 22.1351 19.1782 22.5334C18.356 22.9316 17.4731 23.1777 16.5295 23.2717V27.6667H14.5295ZM26.4935 28.9537L2.24219 4.70236L3.64752 3.29736L27.8989 27.5487L26.4935 28.9537Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/mic-off.06e1e616f562b3b21c70f47b602bdcd2.svg";
export { ForwardRef as ReactComponent };